import { SAFE_TX_STATUS_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  monitor: {
    title: "System Status",
    signer: {
      title: "Signer",
      address: "Address",
      balance: "Balance",
      ok: "Healthy",
      low: "Low",
      critical: "Critical",
      hintOk: "Balance is sufficient for normal operation.",
      hintLow: "Balance is low. Top up soon to keep signing transactions.",
      hintCritical: "Critical balance. Transactions cannot be signed without a top-up.",
    },
    votingSafe: {
      title: "Voting Safe",
    },
    censusSafe: {
      title: "Census Safe",
    },
    safe: {
      address: "Address",
      threshold: "Required signatures",
      status: "Status",
      ok: "No pending",
      pendingCount: "{{count}} pending",
      oldestPending: "Oldest",
      minutes: "min",
      viewInSafe: "View in Safe",
    },
  },
  actions: {
    refreshAllowlists: {
      button: "Refresh auto-updatable allowlists",
      success: "Allowlists updated: {{processedCount}} processed, {{skippedCount}} skipped, {{errorCount}} errors.",
      error: "Failed to refresh auto-updatable allowlists.",
    },
    executePending: {
      button: "Execute pending transactions",
      success: "Transactions: {{executed}} executed, {{failed}} failed out of {{totalPending}} pending.",
      error: "Failed to execute pending transactions.",
    },
  },
  transactions: {
    title: "Pending Transactions",
    votingTitle: "Pending Transactions - Voting",
    censusTitle: "Pending Transactions - Census",
    safeTxHash: "Transaction Hash",
    nonce: "Nonce",
    to: "To",
    value: "Value",
    confirmations: "Confirmations",
    submissionDate: "Date",
    status: "Status",
    actions: "Actions",
    view: "View",
    empty: "No pending transactions",
    executable: "Executable",
    pending: "Pending",
  },
  safeTransactions: {
    votingTitle: "Transaction History - Voting",
    censusTitle: "Transaction History - Census",
    sectionTitle: "Transaction History",
    title: "Title",
    safeTxHash: "Transaction Hash",
    nonce: "Nonce",
    to: "To",
    confirmations: "Confirmations",
    createdAt: "Date",
    status: "Status",
    actions: "Actions",
    view: "View",
    empty: "No transactions",
    statusValues: {
      [SAFE_TX_STATUS_ENUM.PROPOSED]: "Proposed",
      [SAFE_TX_STATUS_ENUM.EXECUTED]: "Executed",
      [SAFE_TX_STATUS_ENUM.FAILED]: "Failed",
    },
  },
}
